<template>
  <div class="order finDetails">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.detailsDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务明细</h3>
      <ny-date-range @change="dateChange" class="el-date-editor" :shortcut="true" v-model="date"></ny-date-range>
      <div class="selectBox clearfix">
        <ny-select
          :data="financial.userTypeMenu"
          v-model="financial.curUserType"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userType"
          placeholder="请选择"
          class="advertiseSelect input_sm mb20"
        ></ny-select>
        <ny-select
          :data="financial.userMenu"
          v-model="financial.curUserMenu"
          :keyValue="['value', 'name']"
          @changeSelectMenu="changeSelect"
          type="userMenu"
          placeholder="请选择"
          class="advertiseSelect input_sm mb20"
        ></ny-select>
        <el-input class="searchBox mb20" icon="search" v-model="accountName" placeholder="请输入账户名称"></el-input>
        <el-input
          class="searchBox mb20"
          icon="search"
          v-model="adverName"
          placeholder="请输入广告主/代理商名称"
        ></el-input>
        <ny-select
          :data="financial.detailsTypeMenu"
          v-model="financial.curDetailsType"
          :keyValue="['value', 'name']"
          @changeSelectMenu="changeSelect"
          type="detailsType"
          placeholder="请选择"
          class="advertiseSelect input_sm mb20"
        ></ny-select>
        <el-button class="oprSuccess mr55 mb20" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.detailsPage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        ></ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, NyDateRange } from '@/global/components';
import { mapGetters } from 'vuex';
export default {
  name: 'advertiser',
  data () {
    return {
      downloadExc: '',
      date: [],
      startTime: '',
      endTime: '',
      addPrice: {
        title: '加款金额',
        type: 'add'
      },
      refund: {
        title: '退款金额',
        type: 'refund'
      },
      page: {
        headers: {
          name: '财务',
          adName: '广告名称',
          id: 'ID'
        },
        data: [
          {
            name: '1345',
            adName: '创意',
            id: '12'
          },
          {
            name: '1345',
            adName: '创意',
            id: '11'
          }
        ]
      },
      adverName: '',
      accountName: '',
      loading: false,
      menuList: [
        {
          name: '航天',
          value: '1'
        },
        {
          name: '媒体',
          value: '2'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      await this.$store.dispatch('finance/getUserTypeMenu')
      this.$store.dispatch('finance/getFinDetailsTypeMenu', { userType: this.financial.curUserType })
      await this.getUserMenu({ value: this.financial.curUserType })
      this.getFinDetailsInfo()
    },
    getUserMenu ({ startTime, endTime, value } = {}) {
      this.$store.dispatch('finance/getUserMenu', {
        userType: this.financial.curUserType,
        startTime,
        endTime
      })
    },
    getFinDetailsInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('finance/getFinDetailsTable', {
        userType: this.financial.curUserType,
        currentPage,
        pageSize,
        accountName: this.accountName,
        adverName: this.adverName,
        userId: this.financial.curUserMenu,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.financial.curDetailsType
      })
    },
    changeSelect ({ value, type }) {
      if (type === 'userType') {
        this.getUserMenu({ value })
      }
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getFinDetailsInfo({ currentPage, pageSize })
    },
    handleClick (val) {
    },
    disDate (time) {
      return new Date(time) > Date.now();
    },
    dateChange (date) {
      this.startTime = date[0]
      this.endTime = date[1]
      this.getUserMenu({ startTime: date[0], endTime: date[1] })
    },
    searchData () {
      this.financial.detailsPage.resetData()
      this.getFinDetailsInfo()
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    NyDateRange
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.finDetails {
  .el-date-editor {
    margin-left: 20px;
    margin-top: 20px;
  }
  .tableBox {
    margin-top: 15px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
}
</style>
